import {
  IAgreementTemplateResponse,
  IAgreementTemplatetAggregator,
} from '../agreement-template/types';

export interface ICustomSectionBase {
  position: number;
  title: string;
}

export enum CUSTOM_SECTION_TYPE {
  Text = 1,
  Paragraph = 2,
}

export interface ICustomSectionTypeResponse {
  name: string;
  id: CUSTOM_SECTION_TYPE;
}

export type ICustomSectionType =
  | CUSTOM_SECTION_TYPE
  | ICustomSectionTypeResponse;

export interface ICustomSectionTemplateMutation extends ICustomSectionBase {
  type: CUSTOM_SECTION_TYPE;
  agreements: IAgreementTemplatetAggregator[];
  customSections: ICustomSectionTemplateMutation[];
}

export interface ICreateCustomSectionTemplate {
  customSectionTemplate: ICustomSectionTemplateMutation;
}
export interface IUpdateCustomSectionTemplate{
  customSectionTemplate: ICustomSectionTemplateMutation;
  customSectionTemplateId: string;
}

export interface ICustomSectionTemplateResponse extends ICustomSectionBase {
  type?: ICustomSectionType;
  agreements: IAgreementTemplateResponse[];
  customSections: ICustomSectionTemplateResponse[];
}
